export default {
	appName: process.env.REACT_APP_NAME || 'eCallMe! - License Portal',
	appVersion: process.env.REACT_APP_PORTAL_VERSION || '0.0.0.1',
};
